import React from 'react';
import { Badge } from '../../components/badge/Badge';
import styles from './badgePage.module.scss';

const BadgePage: React.FC = () => {
	return (
		<div className={styles.badgePageContainer}>
			<Badge />
		</div>
	);
};

export { BadgePage };
